/**
 * Client-side wrapper for the landing page.
 * Provides AI debug context for development debugging.
 */
"use client";

import { type ReactNode } from "react";
import { AiDebugProvider } from "@/components/providers/AiDebugProvider";

interface LandingPageWrapperProps {
  children: ReactNode;
}

export function LandingPageWrapper({ children }: LandingPageWrapperProps) {
  return <AiDebugProvider>{children}</AiDebugProvider>;
}
